module.exports = __webpack_public_path__ + "img/gray-close.85e590ab.svg";